export const iconFontAwesomeHandsHandsClapping = (
	<i className="fa-solid fa-hands-clapping"></i>
);
